import React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";
import PropTypes from "prop-types";

interface Props {
  approvedComments: number;
  allComments: number;
}

export const TableRowCommentsCounts: React.FC<Props> = ({
  approvedComments,
  allComments,
}) => {
  const theme = useTheme();

  if (!allComments || allComments === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "text.disabled",
          fontSize: "0.82rem",
          fontWeight: 500,
          userSelect: "none",
        }}
      >
        0 comments
      </Typography>
    );
  }

  const percentage = Math.min(
    100,
    Math.round((approvedComments / allComments) * 100)
  );
  const isComplete = percentage === 100;
  const barColor = isComplete ? "#10B981" : "#2563EB";

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 130,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.78rem",
            fontWeight: 600,
            color: isComplete ? "success.main" : "text.primary",
          }}
        >
          {`${approvedComments}/${allComments}`}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontSize: "0.7rem",
            fontWeight: 500,
            color: "text.secondary",
          }}
        >
          {percentage}%
        </Typography>
      </Box>

      <Box
        sx={{
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.08)"
              : "rgba(0, 0, 0, 0.06)",
          height: 5,
          width: "100%",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${percentage}%`,
            borderRadius: 3,
            backgroundColor: barColor,
            transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        />
      </Box>
    </Box>
  );
};

TableRowCommentsCounts.propTypes = {
  approvedComments: PropTypes.number.isRequired,
  allComments: PropTypes.number.isRequired,
};

